module.exports = __webpack_public_path__ + "img/explainer-2.d305e252.jpg";